import { H4 } from 'assets/styled';
import { Field, Formik } from 'formik';
import {
  ColumnContainer,
  ColumnContainerSelect,
  FormikOuter,
  FormWrapper,
  Heading,
  RowSpaceBetween,
  StyledCustomSelect,
} from '../EditCompanyDataModal.styled';
import { Input as FormikInput } from 'components/Input/InputFormik';
import { useTranslation } from 'react-i18next';
import { editAddressTabSchema } from '../validation';
import { useGetCountryOptions } from 'utils/hooks/useGetCountryOptions';
import { IOption } from 'components/Select/type';
import { useBreakpointFlag } from 'utils/hooks/useBreakpointFlag';
import { IAddress } from 'types/Address.types';
interface IAddressTabProps {
  address: IAddress;
  setAddress: (address: IAddress) => void;
  setIsValid: (isValid: boolean) => void;
}
export const AddressTab = ({
  address,
  setAddress,
  setIsValid,
}: IAddressTabProps) => {
  const { t } = useTranslation();
  const countryOptions: IOption[] = useGetCountryOptions();
  const { isSmallTablet } = useBreakpointFlag();

  return (
    <FormikOuter>
      <Formik
        enableReinitialize
        onSubmit={() => {
          //
        }}
        initialValues={address}
        validationSchema={editAddressTabSchema}
      >
        {({ values, setFieldValue, handleBlur, errors, isValid }) => {
          const handleBlurFunction = (e: any, name: string) => {
            const value = e.target.value.trim();
            setFieldValue(name, value);
            setAddress(values);
            handleBlur(e);
            setIsValid(isValid);
          };

          return (
            <FormWrapper>
              <RowSpaceBetween>
                <ColumnContainer>
                  <Heading>
                    <H4>{t('Street')}</H4>
                  </Heading>
                  <FormikInput
                    errorMessage={errors['street'] ? errors['street'] : ''}
                    onBlur={(e) => {
                      handleBlurFunction(e, 'street');
                    }}
                    height={'43rem'}
                    name="street"
                    wrapperStyles={{
                      width: isSmallTablet ? '100%' : '300rem',
                      marginTop: '10rem',
                    }}
                  />
                </ColumnContainer>
                <ColumnContainer>
                  <Heading>
                    <H4>{t('House number')}</H4>
                  </Heading>
                  <FormikInput
                    errorMessage={
                      errors['house_number'] ? errors['house_number'] : ''
                    }
                    onBlur={(e) => {
                      handleBlurFunction(e, 'house_number');
                    }}
                    height={'43rem'}
                    name="house_number"
                    wrapperStyles={{
                      width: isSmallTablet ? '100%' : '300rem',
                      marginTop: '10rem',
                    }}
                  />
                </ColumnContainer>
              </RowSpaceBetween>

              <RowSpaceBetween>
                <ColumnContainer>
                  <Heading>
                    <H4>{t('Zip code')}</H4>
                  </Heading>
                  <FormikInput
                    errorMessage={errors['zip_code'] ? errors['zip_code'] : ''}
                    onBlur={(e) => {
                      handleBlurFunction(e, 'zip_code');
                    }}
                    height={'43rem'}
                    name="zip_code"
                    wrapperStyles={{
                      width: isSmallTablet ? '100%' : '300rem',
                      marginTop: '10rem',
                    }}
                  />
                </ColumnContainer>
                <ColumnContainer>
                  <Heading>
                    <H4>{t('City')}</H4>
                  </Heading>
                  <FormikInput
                    errorMessage={errors['city'] ? errors['city'] : ''}
                    onBlur={(e) => {
                      handleBlurFunction(e, 'city');
                    }}
                    height={'43rem'}
                    name="city"
                    wrapperStyles={{
                      width: isSmallTablet ? '100%' : '300rem',
                      marginTop: '10rem',
                    }}
                  />
                </ColumnContainer>
              </RowSpaceBetween>

              <RowSpaceBetween>
                <ColumnContainerSelect>
                  <Heading>
                    <H4>{t('Country')}</H4>
                  </Heading>
                  <Field
                    errorMessage={errors['country'] ? errors['country'] : ''}
                    disabled={false}
                    height={'41rem'}
                    name="country"
                    useFilterOption
                    options={countryOptions}
                    component={StyledCustomSelect}
                    isMulti={false}
                    onSelect={(option: IOption) => {
                      setAddress({
                        ...values,
                        country: option.value,
                      });
                      setIsValid(isValid);
                    }}
                  />
                </ColumnContainerSelect>
              </RowSpaceBetween>
            </FormWrapper>
          );
        }}
      </Formik>
    </FormikOuter>
  );
};
